import { render, staticRenderFns } from "./KeyboardShortcutList.vue?vue&type=template&id=352b9016&"
import script from "./KeyboardShortcutList.vue?vue&type=script&lang=js&"
export * from "./KeyboardShortcutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports